// extracted by mini-css-extract-plugin
export var productImage = "_ni-1";
export var viewLink = "_ni-2";
export var wishlistItem = "_ni-0";